module.exports = __webpack_public_path__ + "media/images/apple_health/watch/clubpilates-c2c96cd20317c3dada855f355fbefe8b.svg";